<template>
  <div>
    <div>
      <input type="checkbox" v-model="isNotOpen">閉業・休業中の施設を含める
    </div>
    <div v-if="isDisplayTotalCount">全{{totalCount}}件</div>
    <div v-for="facility in facilities" :key="facility.id">
      <facilities-line class="pc"
        :facility="facility"
        :isAdmin="isAdmin"
        :isUnlogin="isUnlogin"
        :isPaidUser="isPaidUser"
        :isDisplayAvailabilityNotificationStatus="isDisplayAvailabilityNotificationStatus"
        :hasAvailabilityCondition="hasAvailabilityCondition"
      ></facilities-line>
      <facilities-line-sp class="sp"
        :facility="facility"
        :isAdmin="isAdmin"
        :isUnlogin="isUnlogin"
        :isPaidUser="isPaidUser"
        :isDisplayAvailabilityNotificationStatus="isDisplayAvailabilityNotificationStatus"
        :hasAvailabilityCondition="hasAvailabilityCondition"
      ></facilities-line-sp>
    </div>
    <paginate
      v-model="page"
      :page-count="pageCount"
      :page-range="10"
      :margin-pages="2"
      :click-handler="clickPagination"
      :prev-text="'＜'"
      :next-text="'＞'"
      :container-class="'pagination-container'"
      page-class="pagination-item"
      prev-class="pagination-item"
      next-class="pagination-item"
      active-class="pagination-item-active"
      page-link-class="pagination-link"
      next-link-class="pagination-link"
      prev-link-class="pagination-link">
    </paginate>
  </div> 
</template>
<script>
import FacilitiesLine from './facilitiesLine.vue'
import FacilitiesLineSp from './facilitiesLineSp.vue'
import Paginate from 'vuejs-paginate'

export default {
  data() {
    return {
      page: 1,
      isNotOpen: null
    }
  },
  props: {
    facilities: {
      type: Array,
      default: []
    },
    pageCount:{
      type: Number,
      default: 0
    },
    totalCount:{
      type: Number,
      default: 0
    },
    isAdmin:{
      type: Boolean,
      default: false
    },
    isUnlogin:{
      type: Boolean,
      default: true
    },
    isPaidUser:{
      type: Boolean,
      default: false
    },
    isDisplayAvailabilityNotificationStatus:{
      type: Boolean,
      default: false
    },
    isDisplayTotalCount: {
      type: Boolean, 
      default: false
    },
    hasAvailabilityCondition: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FacilitiesLine, FacilitiesLineSp, Paginate
  },
  methods: {
    clickPagination(val){
      const url = new URL(location.href);
      let params = url.searchParams;
      params.set('page', val)
      location.href = `/facilities?${params}`
    }
  },
  created(){
    const url = new URL(location.href);
    const params = url.searchParams;
    this.page = Number(params.get('page'));
    this.isNotOpen = params.get('is_not_open') === 'true';
  },
  computed: {
    
  },
  watch: {
    isNotOpen(newVal, oldVal){
      if(oldVal === null) return;
      const url = new URL(location.href);
      let params = url.searchParams;
      params.set('is_not_open', newVal)
      location.href = `/facilities?${params}`
    }
  }
}
</script>